import React from 'react';
import { MilestoneProvider } from '@src/context/MilestoneContext';
import useMemberMilestones from '@src/hooks/useMemberMilestones';
import Shelf from './Shelf/Shelf';
import styles from './LearningLifecycles.module.scss';

const LearningLifecycles: React.FC = () => {
  const memberMilestones = useMemberMilestones();

  return (
    <MilestoneProvider>
      <section className={styles.base} data-testid='learning_lifecycles'>
        <Shelf milestones={memberMilestones} numberOfMilestonesToShow={3} />
      </section>
    </MilestoneProvider>
  );
};

export default LearningLifecycles;
